import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Cardiovascular from "./sections/Cardiovascular";
import IntegratedClinicalOverview from "./sections/IntegratedClinicalOverview";
import ClinicalLocationMap from "./sections/ClinicalLocationMap";
import CareCta from "./sections/CareCta";
import Footer from "@/reusable_sections/Footer";
import TrustBadges from "./sections/TrustBadges";
export default function HomePage() {
  return <div className="pb-28 sm:pb-24">
      <Navigation />
      <Cardiovascular />
      <TrustBadges />
      <IntegratedClinicalOverview />
      <ClinicalLocationMap />
      <CareCta />
      <Footer />
    </div>;
}
